// For OSH Authorities Page, add the code of the country you don't want to show

// OSH Authorities Components
export const oshAuthoritiesExceptions = [
    {
        code: 'IS'
    },
    {
        code: 'CH'
    },
    {
        code: 'NO'
    }
]

// Work Accidents Components

export const workAccidentsExceptions = [
    {
        code: 'IS'
    }
]

// Overall Opinion
export const overallOpinionExceptions = [
    {
        code: 'IS'
    }
]

